module.exports = __webpack_public_path__ + "img/step3-basket1.5e389f55.png";